// src/engine/engineCache.js
// Makes sure the service worker has kept every file of the offline engine, so that it also starts without a
// connection. Resolves true when they are kept (or when there is no service worker: nothing could keep them, and the
// app cannot start offline then anyway), false when they could not be kept.
import { isNativeApp } from '../native';

const WAIT = 120000;

export async function keepEngine() {
    if (isNativeApp()) return true; // the engine is part of the app itself
    if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return true;
    let registration;
    try {
        registration = await Promise.race([
            navigator.serviceWorker.ready,
            new Promise((resolve) => setTimeout(() => resolve(null), 5000)),
        ]);
    } catch (error) {
        return false;
    }
    if (!registration || !registration.active) return true; // no service worker running (development)
    return new Promise((resolve) => {
        const channel = new MessageChannel();
        const timer = setTimeout(() => resolve(false), WAIT);
        channel.port1.onmessage = (event) => {
            clearTimeout(timer);
            resolve(Boolean(event.data && event.data.ok));
        };
        registration.active.postMessage({ type: 'CACHE_ENGINE' }, [channel.port2]);
    });
}
